// The full 18-category legacy taxonomy + icons, used by the "Усі категорії"
// secondary entry point (src/pages/AllCategories.js). Extracted out of
// Home.js during the fashion-first Home redesign (2026-09) — Home itself no
// longer renders this grid directly, but the data/images are unchanged and
// still the same 18 categories used everywhere else (search, SEO, sitemap).
import realEstateImage from './img/real-estate.png';
import transportImage from './img/transport.jpg';
import electronicsImage from './img/electronics.png';
import jobImage from './img/job.png';
import servicesImage from './img/services.png';
import homeImage from './img/home.png';
import gardenImage from './img/garden.png';
import childrenImage from './img/children.png';
import petsImage from './img/pets.png';
import fashionImage from './img/fashion.png';
import sportsImage from './img/sports.png';
import healthImage from './img/health.png';
import educationImage from './img/education.png';
import rentalImage from './img/rental.png';
import hobbiesImage from './img/hobbies.png';
import partsImage from './img/parts.png';
import accessoriesImage from './img/accessories.png';
import foodImage from './img/food.png';

export const categories = [
  { name: 'Житло та нерухомість', image: realEstateImage },
  { name: 'Транспорт', image: transportImage },
  { name: 'Гаджети', image: electronicsImage },
  { name: 'Карʼєра', image: jobImage },
  { name: 'Майстри та послуги', image: servicesImage },
  { name: 'Дім та затишок', image: homeImage },
  { name: "Для саду та подвір'я", image: gardenImage },
  { name: 'Малеча', image: childrenImage },
  { name: 'Домашні улюбленці', image: petsImage },
  { name: 'Стиль', image: fashionImage },
  { name: 'Активність та спорт', image: sportsImage },
  { name: 'Б’юті', image: healthImage },
  { name: 'Знання та Навчання', image: educationImage },
  { name: 'Оренда та прокат', image: rentalImage },
  { name: 'Запчастини та аксесуари', image: partsImage },
  { name: 'Аксесуари', image: accessoriesImage },
  { name: 'Продукти та їжа', image: foodImage },
  { name: 'Хобі', image: hobbiesImage },
];
